export const formatSigned = (
  value: number,
  formatted: string = String(value)
): string => (value > 0 ? `+${formatted}` : formatted);
